import React from 'react';
import { getTheme } from '@uifabric/styling';
import { Text } from 'office-ui-fabric-react';
import { SystemPanel } from '../SystemPanel';
import { jsx as _jsx } from "react/jsx-runtime";
export const NoChangeHistoryMessage = () => {
  const {
    palette: {
      blueLight
    }
  } = getTheme();
  return /*#__PURE__*/_jsx(SystemPanel, {
    iconColour: blueLight,
    iconName: 'Ringer',
    title: "No Change History",
    content: /*#__PURE__*/_jsx(Text, {
      children: "There are no Change History entries right now."
    })
  });
};